<ng-template #content_receipt_template let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.printer">
        <div class="side_popup_header">
            <span>{{localService.languageContent.printer.receiptTemplate}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" style="height: calc(100vh - 120px);">
            <div class="row side_popup_body_row">
                <div class="col-12">
                    <app-label [Text]="localService.languageContent.printer.title" [IsMandatory]="true" />
                    <input autocomplete="off" type="text" [(ngModel)]="title"
                        title="{{localService.languageContent.printer.title}}"
                        placeholder="{{localService.languageContent.printer.title}}" />
                </div>
            </div>
            <div class="row styled_row">
                <div class="col-12">
                    <label style="margin-left:20px;font-weight:normal;">
                        <input type="checkbox" [(ngModel)]="isCustomerCopy" />
                        <span style="color:darkslategrey">&nbsp;Is
                            customer copy?</span>
                    </label>
                </div>
            </div>
            <div class="row side_popup_body_row box">
                <div class="col-12">
                    <app-label [Text]="'Receipt Content Type'" />
                    <ngx-select [noAutoComplete]="true" [items]="htmlStyleOption" [optionValueField]="'key'"
                        [optionTextField]="'value'" (select)="onSelectHtmlStyleType()"
                        [(ngModel)]="selectedHtmlStyleType">
                    </ngx-select>
                    <ngx-select [noAutoComplete]="true" [items]="htmlAlignmentOption" [optionValueField]="'key'"
                        [optionTextField]="'value'" (select)="onSetHtmlStyle()" [(ngModel)]="selectedHtmlAlignmentType">
                    </ngx-select>
                    <ngx-select [noAutoComplete]="true" [items]="htmlBorderOption" [optionValueField]="'key'"
                        [optionTextField]="'value'" (select)="onSetHtmlStyle()" [(ngModel)]="selectedHtmlBorder">
                    </ngx-select>
                    <div>
                        <textarea [(ngModel)]="selectedHtmlContent" rows="4" style="width:100%;"
                            (blur)="onSetHtmlStyle()"></textarea>
                        <label style="margin-left:20px;font-weight:normal;">
                            <input type="checkbox" [(ngModel)]="isHtmlStyleActive" (change)="onSetHtmlStyle()" />
                            <span style="color:darkslategrey">&nbsp;Is active?</span>
                        </label>
                    </div>
                    <div>
                        <input type="number" (blur)="onSetHtmlStyle()" [(ngModel)]="selectedWidth"
                            placeholder="Width" />
                        <input type="number" (blur)="onSetHtmlStyle()" [(ngModel)]="selectedMarginTop"
                            placeholder="Margin Top" />
                        <input type="number" (blur)="onSetHtmlStyle()" [(ngModel)]="selectedLineHeight"
                            placeholder="Line Height" />
                        <input type="number" (blur)="onSetHtmlStyle()" [(ngModel)]="selectedFontSize"
                            placeholder="Font Size" />
                        <label style="margin-left:20px;font-weight:normal;">
                            <input type="checkbox" [(ngModel)]="selectedIsBold" (change)="onSetHtmlStyle()" />
                            <span style="color:darkslategrey">&nbsp;Is bold?</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row side_popup_body_row" *ngIf="businessTypes">
                <div class="col-12">
                    <app-label [Text]="localService.languageContent.printer.businessTypes" />
                    <div style="color: orangered;">
                        {{localService.languageContent.printer.do_not_select}}
                    </div>
                    <ngx-select [isFocused]="true" [placeholder]="localService.languageContent.printer.businessTypes"
                        [(ngModel)]="selectedBusinessTypes" [noAutoComplete]="true" [items]="businessTypes"
                        [optionValueField]="'key'" [optionTextField]="'value'" [multiple]="true">
                    </ngx-select>
                </div>
            </div>
            <div class="row side_popup_body_row" *ngIf="paperSizes">
                <div class="col-12">
                    <app-label [Text]="localService.languageContent.printer.paperSize" [IsMandatory]="true" />
                    <ngx-select [isFocused]="true" [placeholder]="localService.languageContent.printer.selectPaperSize"
                        [(ngModel)]="selectedKeyPaperSize" [noAutoComplete]="false" [items]="paperSizes"
                        [optionValueField]="'key'" [optionTextField]="'value'" (select)="onCheckReceiptType()">
                    </ngx-select>
                </div>
            </div>
            <div class="row side_popup_body_row">
                <div class="col-6">
                    <app-label [Text]="localService.languageContent.printer.margin_left" />
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.margin_left}}"
                        [(ngModel)]="marginLeft" style="width:100%;"
                        placeholder="*{{localService.languageContent.printer.margin_left}}"
                        title="{{localService.languageContent.printer.margin_left}}"
                        [ngClass]="marginLeft ? 'en' : ''" />
                </div>
                <div class="col-6">
                    <app-label [Text]="localService.languageContent.printer.margin_top" />
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.margin_top}}"
                        [(ngModel)]="marginTop" style="width:100%;"
                        placeholder="*{{localService.languageContent.printer.margin_top}}"
                        title="{{localService.languageContent.printer.margin_top}}" [ngClass]="marginTop ? 'en' : ''" />
                </div>
            </div>
            <div class="row side_popup_body_row">
                <div class="col-6">
                    <app-label [Text]="localService.languageContent.printer.width" />
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.width}}"
                        [(ngModel)]="width" style="width:100%;"
                        placeholder="*{{localService.languageContent.printer.width}}"
                        title="{{localService.languageContent.printer.width}}" [ngClass]="width ? 'en' : ''" />
                </div>
                <div class="col-6">
                    &nbsp;
                </div>
            </div>
            <div class="row side_popup_body_row" *ngIf="!isFixReceiptType">
                <div class="col-12">
                    <app-label [Text]="localService.languageContent.printer.receipt_options" [IsMandatory]="true" />
                    <div class="banner">
                        <div class="row">
                            <div class="col-12">
                                <input autocomplete="off" type="text" style="margin-bottom: 10px;"
                                    [(ngModel)]="searchKey" title="{{localService.languageContent.common.search}}"
                                    id="{{elementIds.txt_search_key}}"
                                    placeholder="{{localService.languageContent.common.search}}"
                                    (input)="onAction(2)" />
                            </div>
                        </div>
                        <div style="height: calc(100vh - 560px);overflow: auto;">
                            <div class="row styled_row" *ngFor="let item of receiptOptions">
                                <div class="col-12" [ngClass]="item.isInActive ? 'disabled': ''">
                                    <label style="margin-left:20px;font-weight:normal;" title="{{item.value}}">
                                        <input type="checkbox" [(ngModel)]="item.isSelected"
                                            [disabled]="item.isInActive" (change)="onAction(3,item.key)">
                                        <span style="color:darkslategrey">&nbsp;{{item.value}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-6" style="text-align: left;">
                    <span *ngIf="message != ''"
                        [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
                </div>
                <div class="col-6" style="text-align: right;">
                    <button class="btn btn-primary" (click)="onAction(1)">
                        <i class="material-icons" style="color: white;top: 5px;position: relative;">{{itemId ? 'save' :
                            'add'}}</i>
                        <span>{{itemId ? localService.languageContent.common.update :
                            localService.languageContent.common.add}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>